import React, { Component } from 'react';
import { InlineEdit } from "@superops/ui-design-system";

class InlineEditField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text
    };
    this._handleFocus = this._handleFocus.bind(this);
    this._handleFocusOut = this._handleFocusOut.bind(this);
  }

  _handleFocus(text) {}

  _handleFocusOut(text) {
    const { id, description } = this.props.item;
    const status = { name: text, id: id, description: description };
    this.props.updateMethod(status);
  }

  render = () => {
    const { text } = this.props;
    return (
      <InlineEdit
        text={text}
        labelClassName="InlineEditLabel"
        inputClassName="InlineEditInput"
        inputWidth="200px"
        inputHeight="25px"
        labelFontWeight="bold"
        inputFontWeight="bold"
        onFocus={this._handleFocus}
        onFocusOut={this._handleFocusOut}
      />
    );
  };
}

export default InlineEditField;
